function SessionWarningModal({ open, onStay, onLogout }) {
  if (!open) return null;
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>עדיין כאן?</h2>
        <p>תצא מהמערכת בעוד דקה עקב חוסר פעילות.</p>
        <button onClick={onStay}>אני כאן, המשך</button>
        <button onClick={onLogout}>צא עכשיו</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
};

export default SessionWarningModal;
